import { tsrContractsClient } from '../tsrContractsClient';

export const consultationNotesClient = () => tsrContractsClient.consultationNotesHistoryContract;
